import React from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import DialogContent from "@mui/material/DialogContent";
import { Typography, Box, Grid } from "@mui/material";
import ResponsiveButton from "../../../Forms/ResponsiveButton";
import CloseIcon from "@mui/icons-material/Close";

const UserGuideModal = ({ guideModalOpen, setGuideModalOpen }) => {

    const onClose = () => setGuideModalOpen(false);

    const handleClick = (label) => {
        onClose();
        console.log(`${label} clicked!`);

    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        color: "#3B7EB2",
        transform: "translate(-50%, -50%)",
        width: '80%',
        maxWidth: 600,
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '2rem',
    };

    return (
        <Modal
            open={guideModalOpen}
            onClose={onClose}
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <DialogContent>
                <div style={style} className="transition-opacity duration-1000">
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: ["1.2rem", "1.5rem", "1.5rem", "1.8rem"],
                            textAlign: 'center',
                            marginBottom: '0.1rem',
                        }}
                    >
                        Welcome to User Guides!<br />
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 400,
                            fontSize: ["1rem", "1rem", "1rem", "1rem"],
                            textAlign: 'center',
                            marginBottom: '2.5rem',
                        }}
                    >
                        What part of the website would you like a guide on today?
                    </Typography>

                    <Grid container spacing={2} justifyContent="center">
                        {['TRAYS', 'COLLECTION DETAILS', 'REPORTS', 'SETUP', 'SETTINGS'].map((label) => (
                            <Grid item xs={12} key={label}>
                                <Typography
                                    sx={{ textAlign: 'center', fontSize: '1.2rem', cursor: 'pointer' }}
                                    onClick={() => handleClick(label)}
                                >
                                    {label}
                                </Typography>
                                <hr style={{ width: '50%', borderColor: "#3B7EB2", borderWidth: "1px", margin: "15px auto" }} />
                            </Grid>
                        ))}
                    </Grid>

                    <Box
                        className="flex flex-row-reverse mt-8"
                        sx={{
                            "& button + button": {
                                mr: "1rem",
                            },
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <ResponsiveButton
                            variant="contained"
                            color="primary"
                            style={{
                                color: "white",
                                backgroundColor: "#3B7EB2",
                                borderColor: "rgba(63, 81, 181, 0.5)",
                                border: "1px solid",
                                boxShadow: "none",
                            }}
                            onClick={onClose}
                        >
                            CLOSE
                        </ResponsiveButton>
                    </Box>
                </div>
            </DialogContent>
        </Modal>
    );
};

export default UserGuideModal;
